import { jsx, jsxs } from "react/jsx-runtime";
import "@volue/stitches-core";
import filterValidProps from "../../utils/filterValidProps.es.js";
import { clsx } from "../../utils/mergeProps.es.js";
import { responsiveProps } from "../../utils/responsiveProps.es.js";
import { SlotProvider, hasContentSlot, containsChild } from "../../utils/slots.es.js";
import EzFooter from "../EzContent/EzFooter.es.js";
import EzHeader from "../EzContent/EzHeader.es.js";
import EzPreview from "../EzContent/EzPreview.es.js";
import { footer, content, header, preview, orientation, sections, transparentBackground, container, msGrid, grid } from "./EzCard.styles.es.js";
import EzCardHeading from "./EzCardHeading.es.js";
import EzCardSection from "./EzCardSection.es.js";
import EzButton from "../EzButton/EzButton.es.js";
const hasCardSection = (children) => containsChild(children, "EzCardSection");
const unitlessToPx = (value) => typeof value === "number" ? `${value}px` : value;
const EzCard = ({
  title,
  subtitle,
  titleIcon,
  accent,
  actions,
  expandable,
  horizontal: isHorizontal,
  children,
  imageSrc,
  imageMaxWidth: maxWidth,
  imageMaxHeight: maxHeight,
  size,
  isQuiet,
  clickable,
  style = {},
  className,
  transparent,
  truncateHeading,
  ...props
}) => {
  const { imagePosition = "top" } = responsiveProps(props, true, "imagePosition");
  return /* @__PURE__ */ jsx(
    "section",
    {
      ...filterValidProps(props),
      className: clsx(
        className,
        grid({ imagePosition }),
        // dynamically generate styles for IE (which doesn't support inline CSS vars)
        msGrid(unitlessToPx(maxWidth))({ imagePosition }),
        container({
          accent,
          size: size || (isQuiet ? "small" : void 0),
          isQuiet,
          clickable
        }),
        transparent && transparentBackground()
      ),
      style: { ...style, "--sizes-card-preview-max-w": unitlessToPx(maxWidth) },
      children: /* @__PURE__ */ jsxs(
        SlotProvider,
        {
          slots: {
            preview: { className: preview({ position: imagePosition }) },
            header: { className: header() },
            content: { className: content() },
            footer: { className: footer() }
          },
          children: [
            imageSrc && /* @__PURE__ */ jsx(EzPreview, { children: /* @__PURE__ */ jsx("img", { src: imageSrc, alt: "", style: { maxHeight, maxWidth, objectFit: "cover" } }) }),
            title && /* @__PURE__ */ jsx(EzHeader, { children: /* @__PURE__ */ jsx(
              EzCardHeading,
              {
                actions,
                title,
                subtitle,
                titleIcon,
                truncateHeading
              }
            ) }),
            hasContentSlot(children) ? children : /* @__PURE__ */ jsx(
              "div",
              {
                className: clsx(
                  sections(),
                  orientation({ layout: isHorizontal ? "horizontal" : "vertical" })
                ),
                children: hasCardSection(children) ? children : /* @__PURE__ */ jsx(EzCardSection, { children })
              }
            ),
            expandable && /* @__PURE__ */ jsx(EzFooter, { children: /* @__PURE__ */ jsx(EzButton, { variant: "text", onClick: expandable.onClick, children: expandable.isExpanded && expandable.collapseLabel ? expandable.collapseLabel : expandable.expandLabel }) })
          ]
        }
      )
    }
  );
};
EzCard.displayName = "EzCard";
export {
  EzCard as default
};
//# sourceMappingURL=EzCard.es.js.map
